import { createRouter, createWebHistory } from "vue-router";
import { useAppStore, useUserStore } from "./services/Store";
import AdminPlans from "@/views/AdminPlans.vue";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/views/pages/HomePage.vue"),
  },
  {
    path: "/login",
    name: "Login",
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/help",
    name: "HelpCenter",
    component: () => import("@/views/pages/help/HelpCenter.vue"),
  },
  {
    path: "/help/:slug",
    name: "HelpArticle",
    component: () => import("@/views/pages/help/HelpArticle.vue"),
  },
  {
    path: "/about-us",
    name: "About",
    component: () => import("@/views/pages/AboutUs.vue"),
  },
  {
    path: "/contact-us",
    name: "ContactUs",
    component: () => import("@/views/pages/ContactUs.vue"),
  },
  {
    path: "/admin-plans",
    name: "AdminPlans",
    component: AdminPlans,
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  // TEMPORARY — Content Intelligence Research Pack manual testing
  // interface. Direct URL only, no nav link. Delete this entry along
  // with src/views/admin/ResearchPackTest.vue,
  // ResearchPackTestController.php, and its route in routes/api.php
  // once Research Pack quality review is complete.
  {
    path: "/admin/research-test",
    name: "ResearchPackTest",
    component: () => import("@/views/admin/ResearchPackTest.vue"),
    // Admin only for launch (was admin + user for testing).
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/terms-and-conditions",
    name: "Terms and Conditions",
    component: () => import("@/views/pages/TermAndCondition.vue"),
  },
  {
    path: "/faqs",
    name: "FAQS",
    component: () => import("@/views/pages/Faqs.vue"),
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    component: () => import("@/views/pages/PrivacyPolicy.vue"),
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: () => import("@/views/ForgotPassword.vue"),
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: () => import("@/views/ResetPassword.vue"),
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("@/views/Register.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("@/views/Dashboard.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/dashboard/profile",
    name: "Admin Profile",
    component: () => import("@/views/profile/AdminProfile.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/user",
    name: "User",
    component: () => import("@/views/User.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/agent",
    name: "Agent",
    component: () => import("@/views/Agent.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/addons",
    name: "Addons",
    component: () => import("@/views/Addons.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/plan",
    name: "Plan",
    component: () => import("@/views/Plan.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/new-plan",
    name: "New Plans",
    component: () => import("@/views/NewPlanAdmin.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/website",
    name: "Website",
    // component: () => import("@/views/Website.vue"),
    component: () => import("@/views/users/website/AdimWebsite.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/subscriptions",
    name: "Subscriptions",
    component: () => import("@/views/Subscriptions.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/changelog",
    name: "Changelog",
    component: () => import("@/views/Changelog.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/our-sites",
    name: "SiteStats",
    component: () => import("@/views/SiteStats.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/prospecting",
    name: "Prospecting",
    component: () => import("@/views/Prospecting.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/prospecting/review",
    name: "ProspectingReview",
    component: () => import("@/views/ProspectingReview.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/prospecting/:id",
    name: "ProspectingCampaign",
    component: () => import("@/views/ProspectingCampaign.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/our-chatbot",
    name: "OurChatbot",
    component: () => import("@/views/OurChatbot.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/subscribers",
    name: "LaunchSubscribers",
    component: () => import("@/views/LaunchSubscribers.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/ai-usage",
    name: "AiUsage",
    component: () => import("@/views/AiUsage.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/publish-articles",
    name: "PublishArticles",
    component: () => import("@/views/PublishArticles.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/invoices",
    name: "Invoices",
    component: () => import("@/views/Invoices.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/commissions",
    name: "Commissions",
    component: () => import("@/views/Commissions.vue"),
    meta: { requiresAuth: true, roles: ["admin"] },
  },
  {
    path: "/agents",
    name: "Agents",
    component: () => import("@/views/agents/Dashboard.vue"),
    meta: { requiresAuth: true, roles: ["agent"] },
  },
  {
    path: "/agent/profile",
    name: "Agent Profile",
    component: () => import("@/views/profile/AgentsProfile.vue"),
    meta: { requiresAuth: true, roles: ["agent"] },
  },
  {
    path: "/agents/users",
    name: "Users",
    component: () => import("@/views/agents/Users.vue"),
    meta: { requiresAuth: true, roles: ["agent"] },
  },
  {
    path: "/agents/create-user",
    name: "Create User",
    component: () => import("@/views/agents/CreateUser.vue"),
    meta: { requiresAuth: true, roles: ["agent"] },
  },
  {
    path: "/user/dashboard",
    name: "User Dashboard",
    // Was wrongly pointed at views/users/dashboard/Dashboard.vue — that
    // file is the ADMIN dashboard (Total Users/Agents/Commissions), not
    // a per-user page, and had nothing to do with the "user" role this
    // route requires. views/users/dashboard/Overview.vue is the real,
    // already-built per-user dashboard (in-progress/pipeline stats,
    // Needs Attention) that simply wasn't wired to any route. Routed via
    // UserDashboardPage.vue (not Overview.vue directly) so this
    // top-level route gets the sidebar/header/footer — Overview.vue
    // itself doesn't self-wrap in UserLayouts, since it's also reused
    // as a child route inside WebsiteWorkspaceLayout.vue, which already
    // provides that layout for its children.
    component: () => import("@/views/users/dashboard/UserDashboardPage.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
  },
  {
    path: "/user/needs-attention",
    name: "NeedsAttention",
    component: () => import("@/views/users/dashboard/NeedsAttentionPage.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
  },
  {
    path: "/user/profile",
    name: "User Profile",
    component: () => import("@/views/profile/UserProfile.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
  },
  {
    path: "/user/website",
    name: "User Website",
    component: () => import("@/views/users/website/UserWebsite.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
  },
  // Phase 1 — new website-scoped workspace routes, added ALONGSIDE the
  // existing flat routes above. Nothing removed, nothing renamed. Reuses
  // the exact same existing feature components (Overview, Article,
  // AuditTab, Performance, UserSetting) — no replacement pages.
  {
    path: "/user/website/:websiteId",
    component: () => import("@/views/users/website/WebsiteWorkspaceLayout.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
    children: [
      {
        path: "overview",
        name: "WorkspaceOverview",
        component: () => import("@/views/users/website/websitedashboard/Overview.vue"),
      },
      {
        path: "articles",
        name: "WorkspaceArticles",
        component: () => import("@/views/users/website/websitedashboard/Article.vue"),
      },
      {
        path: "publish",
        name: "WorkspacePublish",
        component: () => import("@/views/users/publishArticle/WorkspacePublishLauncher.vue"),
      },
      {
        path: "keywords",
        name: "WorkspaceKeywords",
        component: () => import("@/views/users/keywordAutomation/KeywordAutomation.vue"),
      },
      {
        path: "schedule",
        name: "WorkspaceSchedule",
        component: () => import("@/views/users/schedule/Schedule.vue"),
      },
      {
        path: "on-page-seo",
        name: "WorkspaceOnPageSeo",
        component: () => import("@/views/users/website/websitedashboard/AuditTab.vue"),
        meta: { requiresAuth: true, roles: ["user"], auditSubTab: "onpage" },
      },
      {
        path: "technical-seo",
        name: "WorkspaceTechnicalSeo",
        component: () => import("@/views/users/website/websitedashboard/AuditTab.vue"),
        meta: { requiresAuth: true, roles: ["user"], auditSubTab: "technical" },
      },
      {
        path: "performance",
        name: "WorkspacePerformance",
        component: () => import("@/views/users/website/websitedashboard/Performance.vue"),
      },
      {
        path: "chatbot",
        name: "WorkspaceChatbot",
        component: () => import("@/views/users/website/websitedashboard/Chatbot.vue"),
      },
      {
        path: "settings",
        name: "WorkspaceSettings",
        component: () => import("@/views/users/website/websitedashboard/UserSetting.vue"),
      },
    ],
  },
  {
    path: "/user/subscriptions",
    name: "User Subscriptions",
    component: () => import("@/views/users/subscription/Subscriptions.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
  },
  {
    path: "/user/publish-articles",
    name: "User Publish Articles",
    component: () => import("@/views/users/publishArticle/PublishArticles.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
  },
  {
    path: "/user/keyword-automation",
    name: "User Keyword Automation",
    component: () => import("@/views/users/keywordAutomation/KeywordAutomation.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
  },
  // Standalone Schedule, for the sidebar's global "Schedule" link. Reuses
  // the EXACT same component the website-workspace "Schedule" tab already
  // uses (@/views/users/schedule/Schedule.vue) — it already self-wraps in
  // UserLayouts and treats websiteId as optional when not embedded, so no
  // component changes were needed to add this route.
  {
    path: "/user/schedule",
    name: "User Schedule",
    component: () => import("@/views/users/schedule/Schedule.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
  },
  // Real "Audit & Fix" landing page — replaces the earlier placeholder
  // that routed to the plain Website list. Shows every website's
  // technical-SEO audit health at a glance (reusing the same endpoint
  // each website's own Overview.vue already uses), with a direct link
  // into that site's Technical SEO tab to actually review and fix it.
  {
    path: "/user/audit",
    name: "User Audit",
    component: () => import("@/views/users/website/AuditOverview.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
  },
  {
    path: "/user/request-publish-articles",
    name: "Request Publish Articles",
    component: () => import("@/views/users/publishArticle/CreateArticle.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
  },
  {
    path: "/user/invoices",
    name: "User Invoices",
    component: () => import("@/views/users/Invoices.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
  },
  {
    path: "/user/plan",
    name: "User Plan",
    component: () => import("@/views/users/Plan.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
  },
  {
    path: "/user/new-plan",
    name: "New Plan",
    component: () => import("@/views/users/website/NewPlan.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
  },
  {
    path: "/user/create-new-website",
    name: "New webs",
    component: () => import("@/views/users/website/CreateWebsiteWrapper.vue"),
    meta: { requiresAuth: true, roles: ["user"] },
  },
  {
    path: "/unauthorized",
    name: "Unauthorized",
    component: () => import("@/views/Unauthorized.vue"),
  },
  {
    path: "/google",
    name: "Google",
    component: () => import("@/views/Google.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

let previousUrl: any = null;

router.beforeEach((to, from, next) => {
  const authStore = useUserStore();
  const appStore = useAppStore();
  const isAuthenticated = authStore.isAuthenticated;
  const userRole = authStore.userRole;
  const defaultPlan = authStore?.user?.defaultPlan;

  previousUrl = from.fullPath;

  appStore.setLoading(true);

  const authPages = ["/login", "/register", "/forgot-password", "/reset-password"];

  if (isAuthenticated && authPages.includes(to.path)) {
    if (defaultPlan !== null && userRole === "user") {
      return next("/user/plan");
    }
    switch (userRole) {
      case "admin":
        return next("/dashboard");
      case "agent":
        return next("/agents");
      case "user":
        return next("/user/dashboard");
      default:
        return next("/dashboard");
    }
  }

  const isValid = authStore.checkSessionExpiry();
  if (!isValid) {
    return next("/login");
  }

  // ✳️ If user has defaultPlan and role is 'user', only allow access to /user/plan
  if (
    isAuthenticated &&
    userRole === "user" &&
    defaultPlan !== null &&
    to.path !== "/user/plan"
  ) {
    return next("/user/plan");
  }

  // Route requires authentication
  if (to.meta.requiresAuth) {
    if (!isAuthenticated) {
      return next("/login"); // Not logged in
    }

    // Role mismatch
    if (to.meta.roles && !to.meta.roles.includes(userRole)) {
      return next(previousUrl || "/");
    }
  }

  return next(); // Proceed normally
});

router.afterEach(() => {
  const appStore = useAppStore();
  appStore.setLoading(false); // Delay for UX
});

// Our own AI chatbot bubble on the PUBLIC pages (home, pricing, about…):
// loaded once when it's switched on in Admin → Our Chatbot, and hidden on
// every logged-in page (dashboard, admin) so it never covers the app.
let houseChatbotRequested = false;
router.afterEach((to) => {
  const isPublic = !to.matched.some((r) => r.meta?.requiresAuth);
  const bubble = document.getElementById("seood-chatbot");
  if (bubble) bubble.style.display = isPublic ? "" : "none";
  if (!isPublic || houseChatbotRequested) return;
  houseChatbotRequested = true;
  import("./services/ApiService")
    .then(({ apiService }) => apiService.get("/house-chatbot"))
    .then((res) => {
      const key = res?.data?.key;
      const src = res?.data?.src;
      if (!key || !src || document.querySelector("script[data-key]")) return;
      const s = document.createElement("script");
      s.src = src;
      s.defer = true;
      s.setAttribute("data-key", key);
      document.body.appendChild(s);
    })
    .catch(() => {});
});

export default router;